module.exports = __webpack_public_path__ + "static/img/macrogenome_1.3ac18a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/macrogenome_1.png
// module id = rPpZ
// module chunks = 16